import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "primary-color overview-name"
}
const _hoisted_4 = {
  class: "pr-2 d-flex",
  style: {"width":"10%"}
}
const _hoisted_5 = {
  key: 0,
  class: "text-center pa-4"
}
const _hoisted_6 = { class: "text-h6 mb-2" }
const _hoisted_7 = {
  key: 1,
  class: "d-flex justify-center"
}
const _hoisted_8 = { class: "chart-container" }
const _hoisted_9 = ["width", "viewBox"]
const _hoisted_10 = { class: "grid" }
const _hoisted_11 = ["y1", "x2", "y2"]
const _hoisted_12 = ["x1", "x2", "y2"]
const _hoisted_13 = ["d", "stroke", "stroke-dasharray", "opacity"]
const _hoisted_14 = ["cx", "cy", "fill", "stroke", "fill-opacity"]
const _hoisted_15 = ["x", "y"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["x", "y"]
const _hoisted_18 = ["x", "y"]
const _hoisted_19 = {
  key: 1,
  class: "text-center pa-4"
}
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "p-text date-label" }
const _hoisted_22 = { class: "small" }
const _hoisted_23 = { class: "p-text mt-1" }
const _hoisted_24 = { class: "d-flex align-center justify-space-between" }
const _hoisted_25 = { class: "p-text date-label mb-0" }
const _hoisted_26 = { class: "p-text" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }

import {useSettingsStore} from "@/api/store/settings";
import {computed, reactive, ref, watch, onMounted, onActivated} from "vue";
import {healthTrackerService, type HealthTracker, type TrackerTemplate} from "@/api/services/healthTracker";
import {useRouter} from "vue-router";
import moment from "moment/moment";
import LeftAndRightArrows from "@/views/DocumentComponents/DocumentSurveys/Partials/LeftAndRightArrows.vue";


const chartHeight = 250;
const chartPadding = 50;


export default /*@__PURE__*/_defineComponent({
  __name: 'HealthTrackerView',
  setup(__props) {

_useCssVars(_ctx => ({
  "bb352a54": (_unref(settingsStore).settings.primaryColor),
  "v1050c5aa": (_unref(buttonColor))
}))

const router = useRouter();
const settingsStore = useSettingsStore();

const buttonColor = settingsStore.settings.buttonColor;

const state = reactive({
  activeTracker: null as HealthTracker | null,
  trackerTemplates: [] as TrackerTemplate[],
  allTrackerEntries: [] as any[],
  trackerEntriesWithValue: [] as any[],
  upcomingEntry: {} as any,
  latestEntries: [] as any[],
  currentItemIndex: 0,
  availableItems: [] as any[],
});



const selectedTemplate = ref<TrackerTemplate | null>(null);

const hasActiveTracker = computed(() => {
  return state.activeTracker && state.activeTracker.is_active;
});

const trackerHasStarted = computed(() => {
  if (!state.activeTracker) return false;
  
  const today = moment();
  const startDate = moment(state.activeTracker.start_date);
  return today.isSameOrAfter(startDate, 'day');
});

const currentTracker = computed(() => {
  return state.activeTracker;
});

const currentItem = computed(() => {
  if (state.availableItems.length === 0) return null;
  return state.availableItems[state.currentItemIndex];
});

const latestEntriesByDate = computed(() => {
  // Only completed entries (isSubmitted true or value not null)
  const completed = state.latestEntries.filter((entry: any) => entry.value !== null && entry.value !== undefined);
  // Group by date (YYYY-MM-DD), pick the latest by entry_datetime per date
  const grouped: { [date: string]: any } = {};
  completed.forEach((entry: any) => {
    const date = moment(entry.entry_datetime).format('YYYY-MM-DD');
    if (!grouped[date] || moment(entry.entry_datetime).isAfter(grouped[date].entry_datetime)) {
      grouped[date] = entry;
    }
  });
  // Return sorted by date descending
  return Object.values(grouped).sort((a: any, b: any) => moment(b.entry_datetime).diff(moment(a.entry_datetime)));
});

// Chart-related computed properties and methods
const chartWidth = computed(() => {
  const containerWidth = Math.min(window.innerWidth - 80, 600); // Responsive width with max
  return Math.max(containerWidth, 300); // Minimum width
});
const minValue = computed(() => {
  if (selectedTemplate.value?.scale_min !== undefined) return selectedTemplate.value.scale_min;
  if (currentTracker.value?.tracker_template?.scale_min !== undefined) return currentTracker.value.tracker_template.scale_min;
  return 0;
});

const maxValue = computed(() => {
  if (selectedTemplate.value?.scale_max !== undefined) return selectedTemplate.value.scale_max;
  if (currentTracker.value?.tracker_template?.scale_max !== undefined) return currentTracker.value.tracker_template.scale_max;
  return 10;
});

const yAxisTicks = computed(() => {
  const ticks = [];
  const step = Math.max(1, Math.floor((maxValue.value - minValue.value) / 5));
  for (let i = minValue.value; i <= maxValue.value; i += step) {
    ticks.push(i);
  }
  if (ticks[ticks.length - 1] !== maxValue.value) {
    ticks.push(maxValue.value);
  }
  return ticks;
});

const getXPosition = (index: number) => {
  const availableWidth = chartWidth.value - (chartPadding * 2);
  const stepWidth = periodBasedEntries.value.length > 1 
    ? availableWidth / (periodBasedEntries.value.length - 1)
    : availableWidth / 2; // Center single point
  return chartPadding + (index * stepWidth);
};

const getYPosition = (value: number) => {
  const availableHeight = chartHeight - (chartPadding * 2) - 40; // Extra space for x-axis labels
  const valueRange = maxValue.value - minValue.value;
  if (valueRange === 0) return chartPadding + availableHeight / 2; // Center if no range
  const normalizedValue = (value - minValue.value) / valueRange;
  return chartPadding + (availableHeight * (1 - normalizedValue));
};

const chartPath = computed(() => {
  if (periodBasedEntries.value.length === 0) return '';
  
  let path = '';
  periodBasedEntries.value.forEach((entry, index) => {
    const x = getXPosition(index);
    const y = getYPosition(entry.value);
    
    if (index === 0) {
      path += `M ${x} ${y}`;
    } else {
      path += ` L ${x} ${y}`;
    }
  });
  
  return path;
});

const hasAnySubmittedEntries = computed(() => {
  return periodBasedEntries.value.some(entry => entry.isSubmitted);
});

const getHealthTrackerData = async () => {
  try {
    // Get active tracker
    const activeTracker = await healthTrackerService.getActiveTracker();
    state.activeTracker = activeTracker;
    
    if (activeTracker && activeTracker.tracker_template) {
      selectedTemplate.value = activeTracker.tracker_template;
      
      // Always fetch entries to show the structure
      await fetchTrackerEntries();
    }
    
    // Get upcoming entries
    const upcomingEntries = await healthTrackerService.getUpcomingEntries();
    state.upcomingEntry = upcomingEntries[0] || {};
    
    // Get latest entries
    const latestEntries = await healthTrackerService.getLatestEntries();
    state.latestEntries = latestEntries;
    
  } catch (error) {
    console.error('Error fetching health tracker data:', error);
  }
};

// Function to handle moving to the next item
const nextItem = () => {
  if (state.availableItems.length > 1) {
    state.currentItemIndex = (state.currentItemIndex + 1) % state.availableItems.length;
    filterEntriesForCurrentItem();
  }
};

// Function to handle moving to the previous item
const previousItem = () => {
  if (state.availableItems.length > 1) {
    state.currentItemIndex = state.currentItemIndex === 0 
      ? state.availableItems.length - 1 
      : state.currentItemIndex - 1;
    filterEntriesForCurrentItem();
  }
};



const fetchTrackerEntries = async () => {
  if (!currentTracker.value?.id) {
    state.allTrackerEntries = [];
    state.trackerEntriesWithValue = [];
    state.availableItems = [];
    return;
  }

  try {
    const response = await healthTrackerService.getTrackerEntries(
      currentTracker.value.id
    );
    
    // Store all entries - response is now the entries array directly
    state.allTrackerEntries = response || [];

    // Debug: log allTrackerEntries
    console.log('allTrackerEntries:', state.allTrackerEntries);

    // Extract unique items from the entries
    const itemsMap = new Map();
    
    if (response && response.length > 0) {
      response.forEach((entry: any) => {
        if (entry.tracker_template_item && !itemsMap.has(entry.item_id)) {
          itemsMap.set(entry.item_id, entry.tracker_template_item);
        }
      });
    }
    // Note: Removed the fallback to tracker_template.items since it doesn't exist in the type
    
    state.availableItems = Array.from(itemsMap.values());

    // If no current item is selected, select the first one
    if (state.availableItems.length > 0 && state.currentItemIndex >= state.availableItems.length) {
      state.currentItemIndex = 0;
    }

    // Filter entries for the current item and add response_value
    filterEntriesForCurrentItem();
    
  } catch (error) {
    console.error('Error fetching tracker entries:', error);
    state.allTrackerEntries = [];
    state.trackerEntriesWithValue = [];
    state.availableItems = [];
  }
};

const filterEntriesForCurrentItem = () => {
  if (!currentItem.value) {
    state.trackerEntriesWithValue = [];
    return;
  }

  // Filter entries for the current item and sort by due_datetime
  let filteredEntries = state.allTrackerEntries
    .filter((entry: any) => entry.item_id === currentItem.value.id)
    .sort((a: any, b: any) => new Date(a.due_datetime).getTime() - new Date(b.due_datetime).getTime())
    .map((entry: any) => ({
      ...entry,
      value: entry.response_value || 0, // Use 0 as default for null response_value
      entry_datetime: entry.due_datetime, // Use due_datetime for chart display
      isSubmitted: entry.response_value !== null, // Track if entry was submitted
    }));

  // If tracker has started but no entries exist, create a starting point from tracker start date
  if (filteredEntries.length === 0 && currentTracker.value?.start_date) {
    const startDate = moment(currentTracker.value.start_date);
    if (moment().isSameOrAfter(startDate, 'day')) {
      filteredEntries = [{
        id: 'start',
        due_datetime: currentTracker.value.start_date,
        entry_datetime: currentTracker.value.start_date,
        value: 0,
        isSubmitted: false,
        item_id: currentItem.value.id,
        tracker_template_item: currentItem.value
      }];
    }
  }

  state.trackerEntriesWithValue = filteredEntries;
};

watch(currentItem, () => {
  if (currentItem.value) {
    filterEntriesForCurrentItem();
  }
});

const getEntryDate = (entry: any) => {
  if (!entry?.entry_datetime) return { month: '', year: '' };

  return {
    month: moment(entry.entry_datetime).format('DD MMM'),
    year: moment(entry.entry_datetime).format('YYYY'),
  };
};

const getDueOrOverdue = computed(() => {
  if (!state.upcomingEntry?.due_date) return '';
  
  const today = moment();
  const entryDate = moment(state.upcomingEntry.due_date);

  if (today.isSame(entryDate, 'day')) {
    return '(Due)';
  }

  if (today.isAfter(entryDate)) {
    return '(Overdue)';
  }

  return '';
});

const disableEntryIfCompletedToday = computed(() => {
  const today = moment().format('YYYY-MM-DD');
  const currentTemplateId = state.upcomingEntry?.tracker_template_id;
  
  // Check if there's a completed entry today for the current template
  const latestEntryToday = state.latestEntries.find((entry) => 
    moment(entry.entry_datetime).format('YYYY-MM-DD') === today && 
    entry.tracker_template_id === currentTemplateId
  );

  return !!latestEntryToday;
});

const onCompleteEntry = () => {
  if (!currentTracker.value?.id || !state.upcomingEntry?.due_date) return;
  
  const trackerId = currentTracker.value.id;
  const entryDate = moment(state.upcomingEntry.due_date).format('YYYY-MM-DD');
  
  router.push({ 
    name: 'tracker-entry', 
    params: { 
      id: trackerId.toString(),
      date: entryDate 
    } 
  });
};

const upcomingButtonLabel = computed(() => {
  if (!state.upcomingEntry?.due_date) return '';
  const today = moment();
  const due = moment(state.upcomingEntry.due_date);
  if (today.isSame(due, 'day') || today.isAfter(due, 'day')) {
    return 'Completed';
  }
  return 'Coming Soon';
});

// --- Add new computed for period-based chart data ---
const trackerDuration = computed(() => {
  // Prefer the duration from the tracker template, fallback to 1
  return currentTracker.value?.tracker_template?.duration ?? 1;
});

const trackerFrequency = computed(() => {
  // Prefer the frequency from the tracker template, fallback to 'weekly'
  return currentTracker.value?.tracker_template?.frequency ?? 'weekly';
});

const getPeriodLabel = (index: number) => {
  switch (trackerFrequency.value.toLowerCase()) {
    case 'daily':
      return `D${index + 1}`;
    case 'weekly':
      return `W${index + 1}`;
    case 'monthly':
      return `M${index + 1}`;
    default:
      return `${index + 1}`;
  }
};

const periodLabels = computed(() => {
  return Array.from({ length: trackerDuration.value }, (_, i) => getPeriodLabel(i));
});

const periodBasedEntries = computed(() => {
  if (!currentItem.value) return [];
  const entries = state.allTrackerEntries
    .filter((entry: any) => entry.item_id === currentItem.value.id && entry.due_datetime)
    .sort((a: any, b: any) => new Date(a.due_datetime).getTime() - new Date(b.due_datetime).getTime());

  // Use the earliest entry's due_datetime as the start date, or fallback to tracker start_date
  let startDate: moment.Moment | null = null;
  if (entries.length > 0) {
    startDate = moment(entries[0].due_datetime);
  } else if (currentTracker.value?.start_date) {
    startDate = moment(currentTracker.value.start_date);
  }
  if (!startDate) return [];

  const periodMap = new Map<number, any>();
  entries.forEach((entry: any) => {
    const entryDate = moment(entry.due_datetime);
    let periodIdx = 0;

    switch (trackerFrequency.value.toLowerCase()) {
      case 'weekly':
        periodIdx = entryDate.startOf('isoWeek').diff(startDate.clone().startOf('isoWeek'), 'weeks');
        break;
      case 'monthly':
        periodIdx = entryDate.startOf('month').diff(startDate.clone().startOf('month'), 'months');
        break;
      case 'daily':
      default:
        periodIdx = entryDate.startOf('day').diff(startDate.clone().startOf('day'), 'days');
        break;
    }

    if (periodIdx >= 0 && periodIdx < trackerDuration.value) {
      // If there are multiple entries for the same period keep the latest submitted one
      const existing = periodMap.get(periodIdx);
      if (!existing || moment(entry.submitted_datetime ?? entry.due_datetime).isAfter(existing.submitted_datetime ?? existing.due_datetime)) {
        periodMap.set(periodIdx, entry);
      }
    }
  });

  // Build the array for the chart, filling missing periods with null
  return Array.from({ length: trackerDuration.value }, (_, i) => {
    const entry = periodMap.get(i);
    // Use response_value for charting, treat null as missing
    const chartValue = entry && entry.response_value !== null ? entry.response_value : null;
    return entry
      ? {
          ...entry,
          value: chartValue,
          isSubmitted: chartValue !== null && chartValue !== undefined,
          periodIdx: i,
        }
      : {
          value: null,
          isSubmitted: false,
          periodIdx: i,
        };
  });
});

onMounted(() => {
  getHealthTrackerData();
});

onActivated(() => {
  // Refresh data when returning from entry page
  getHealthTrackerData();
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "px-0 pb-5 health-tracker",
    style: {"background-color":"#F5F5F5","min-height":"500px"}
  }, {
    default: _withCtx(() => [
      (currentTracker.value && hasActiveTracker.value)
        ? (_openBlock(), _createBlock(_component_v_sheet, {
            key: 0,
            class: "mx-6 border-rounded"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, { class: "d-flex justify-space-between align-center pa-2 pb-0 w-100" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, {
                    class: "text-h6 font-weight",
                    style: {"width":"90%"}
                  }, {
                    default: _withCtx(() => [
                      (trackerHasStarted.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "My Progress"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_2, "My Tracker")),
                      (currentItem.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " (" + _toDisplayString(currentItem.value?.name) + ") ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(LeftAndRightArrows, {
                      onLeft: previousItem,
                      onRight: nextItem
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_container, null, {
                default: _withCtx(() => [
                  (!trackerHasStarted.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_v_icon, {
                          size: "48",
                          color: "primary",
                          class: "mb-3"
                        }, {
                          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                            _createTextVNode("fa fa-calendar-clock", -1)
                          ]))]),
                          _: 1
                        }),
                        _createElementVNode("p", _hoisted_6, "Tracker starts on " + _toDisplayString(_unref(moment)(currentTracker.value?.start_date).format('DD MMM YYYY')), 1),
                        _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-body-2 text-grey-darken-1" }, " Your tracker will become active and you'll be able to start logging entries from this date. ", -1))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          (periodBasedEntries.value.length > 0)
                            ? (_openBlock(), _createElementBlock("svg", {
                                key: 0,
                                width: chartWidth.value,
                                height: chartHeight,
                                class: "line-chart",
                                viewBox: `0 0 ${chartWidth.value} ${chartHeight}`
                              }, [
                                _createElementVNode("g", _hoisted_10, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yAxisTicks.value, (tick) => {
                                    return (_openBlock(), _createElementBlock("line", {
                                      key: `h-grid-${tick}`,
                                      x1: chartPadding,
                                      y1: getYPosition(tick),
                                      x2: chartWidth.value - chartPadding,
                                      y2: getYPosition(tick),
                                      stroke: "#E0E0E0",
                                      "stroke-width": "1"
                                    }, null, 8, _hoisted_11))
                                  }), 128)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(periodBasedEntries.value, (entry, index) => {
                                    return (_openBlock(), _createElementBlock("line", {
                                      key: `v-grid-${index}`,
                                      x1: getXPosition(index),
                                      y1: chartPadding,
                                      x2: getXPosition(index),
                                      y2: chartHeight - chartPadding - 40,
                                      stroke: "#E0E0E0",
                                      "stroke-width": "1"
                                    }, null, 8, _hoisted_12))
                                  }), 128))
                                ]),
                                _createElementVNode("path", {
                                  d: chartPath.value,
                                  stroke: _unref(settingsStore).settings.primaryColor,
                                  "stroke-width": "3",
                                  fill: "none",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-dasharray": hasAnySubmittedEntries.value ? 'none' : '5,5',
                                  opacity: hasAnySubmittedEntries.value ? '1' : '0.5'
                                }, null, 8, _hoisted_13),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(periodBasedEntries.value, (entry, index) => {
                                  return (_openBlock(), _createElementBlock("circle", {
                                    key: `point-${index}`,
                                    cx: getXPosition(index),
                                    cy: getYPosition(entry.value),
                                    r: "8",
                                    fill: entry.isSubmitted ? _unref(settingsStore).settings.primaryColor : '#FFFFFF',
                                    stroke: _unref(settingsStore).settings.primaryColor,
                                    "stroke-width": 2,
                                    "fill-opacity": entry.isSubmitted ? '1' : '1',
                                    class: "data-point"
                                  }, null, 8, _hoisted_14))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yAxisTicks.value, (tick) => {
                                  return (_openBlock(), _createElementBlock("text", {
                                    key: `y-label-${tick}`,
                                    x: chartPadding - 10,
                                    y: getYPosition(tick) + 5,
                                    "text-anchor": "end",
                                    class: "axis-label"
                                  }, _toDisplayString(tick), 9, _hoisted_15))
                                }), 128)),
                                false
                                  ? (_openBlock(), _createElementBlock("g", _hoisted_16, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(periodBasedEntries.value, (entry, index) => {
                                        return (_openBlock(), _createElementBlock("text", {
                                          key: `x-label-${index}`,
                                          x: getXPosition(index),
                                          y: chartHeight - chartPadding + 20,
                                          "text-anchor": "middle",
                                          class: "axis-label"
                                        }, _toDisplayString(periodLabels.value[index]), 9, _hoisted_17))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(periodBasedEntries.value, (entry, index) => {
                                  return (_openBlock(), _createElementBlock("text", {
                                    key: `value-label-${index}`,
                                    x: getXPosition(index),
                                    y: getYPosition(entry.value) - 15,
                                    "text-anchor": "middle",
                                    class: _normalizeClass(entry.isSubmitted ? 'value-label' : 'value-label-unsubmitted')
                                  }, _toDisplayString(entry.isSubmitted ? entry.value : '-'), 11, _hoisted_18))
                                }), 128))
                              ], 8, _hoisted_9))
                            : (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[2] || (_cache[2] = [
                                _createElementVNode("p", { class: "text-body-2 text-grey-darken-1" }, "No data to display", -1)
                              ]))]))
                        ])
                      ]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_sheet, {
            key: 1,
            class: "mx-6 pa-3 border-rounded d-flex align-center justify-center",
            style: {"min-height":"300px"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_v_icon, {
                  size: "64",
                  color: "grey-lighten-1",
                  class: "mb-4"
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("fa fa-chart-line", -1)
                  ]))]),
                  _: 1
                }),
                _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-h6 text-grey-darken-1" }, "No tracker active", -1)),
                _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-body-2 text-grey-darken-1 mt-2" }, " Contact your practitioner to set up a health tracker. ", -1))
              ])
            ]),
            _: 1
          })),
      _createVNode(_component_v_card_title, { class: "mx-3 text-h6 font-weight mt-3" }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
          _createTextVNode("Upcoming Entry", -1)
        ]))]),
        _: 1
      }),
      (state.upcomingEntry && Object.keys(state.upcomingEntry).length > 0)
        ? (_openBlock(), _createBlock(_component_v_sheet, {
            key: 2,
            class: "mx-6 pa-3 border-rounded d-flex align-center justify-space-between"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_21, [
                  _createTextVNode(_toDisplayString(_unref(moment)(state.upcomingEntry?.due_date).format('DD MMM YYYY')) + " ", 1),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(getDueOrOverdue.value), 1)
                ]),
                _createElementVNode("p", _hoisted_23, _toDisplayString(state.upcomingEntry?.tracker_template?.name), 1)
              ]),
              (trackerHasStarted.value)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    color: getDueOrOverdue.value.length === 0 || disableEntryIfCompletedToday.value ? '#ABAAAA' : _unref(settingsStore).settings.buttonColor2,
                    disabled: getDueOrOverdue.value.length === 0 || disableEntryIfCompletedToday.value,
                    class: "text-white b-round-20 complete-button",
                    onClick: onCompleteEntry
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(upcomingButtonLabel.value), 1)
                    ]),
                    _: 1
                  }, 8, ["color", "disabled"]))
                : (_openBlock(), _createBlock(_component_v_chip, {
                    key: 1,
                    color: "info",
                    variant: "outlined",
                    class: "b-round-20"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Available from " + _toDisplayString(_unref(moment)(currentTracker.value?.start_date).format('DD MMM')), 1)
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_sheet, {
            key: 3,
            class: "mx-6 pa-3 border-rounded d-flex align-center justify-space-between"
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createElementVNode("p", { class: "p-text" }, "You have no entries to complete at this time.", -1)
            ]))]),
            _: 1
          })),
      _createVNode(_component_v_card_title, { class: "mx-3 text-h6 font-weight mt-3" }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
          _createTextVNode("Latest Entries", -1)
        ]))]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(latestEntriesByDate.value, (entry) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `entry-${entry.id}`
        }, [
          _createVNode(_component_v_sheet, { class: "mx-6 pa-3 border-rounded mb-2" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(moment)(entry.entry_datetime).format('DD MMM YYYY')), 1),
                _createVNode(_component_v_btn, {
                  class: "b-round-20 view-button",
                  onClick: ($event: any) => (_unref(router).push({ name: 'tracker-entry', params: { id: currentTracker.value?.id, date: _unref(moment)(entry.entry_datetime).format('YYYY-MM-DD') }, query: { readonly: 'true' } }))
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode(" View ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 2
          }, 1024)
        ]))
      }), 128)),
      (latestEntriesByDate.value.length === 0)
        ? (_openBlock(), _createBlock(_component_v_sheet, {
            key: 4,
            class: "mx-6 pa-3 border-rounded d-flex align-center justify-space-between"
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_26, [
                (!trackerHasStarted.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Entries will appear here once your tracker starts on " + _toDisplayString(_unref(moment)(currentTracker.value?.start_date).format('DD MMM YYYY')), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_28, "There is no information to show"))
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})